import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { HospitalsService } from '@core/services/hospitals.service';
import { catchError, map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class HospitalsLoaderGuard  {
    constructor(
        public router: Router,
        private hospitalsService: HospitalsService,
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
        return this.hospitalsService.getUserHospitals().pipe(
            map(userHospitals => {
                this.hospitalsService.changeUserHospitals(userHospitals);

                const currentHospital = this.hospitalsService.getHospitalSelected();
                if (!currentHospital && userHospitals && userHospitals.length > 0) {
                    this.hospitalsService.changeHospitalSelected(userHospitals[0]);
                }

                return true;
            }),
            catchError(error => {
                console.error('Error loading user hospitals:', error);
                this.router.navigateByUrl('login');
                return of(false);
            })
        );
    }
}
